import { TAvatar } from "@/types/TAvatar";
import { useQuery } from "@tanstack/react-query";

export function useSelectedAvatar() {
  return useQuery({
    queryKey: ["selected-avatar"],
    queryFn: async (): Promise<TAvatar> => {
      const response = await fetch("/api/selected_avatar");
      
      if (!response.ok) {
        throw new Error(`Failed to fetch selected avatar: ${response.status}`);
      }
      
      return response.json();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });
}
